// 🔥 CONFIGURACIÓN DEL RESTAURANTE
// Cambia estos datos para cada cliente
import logo from "./assets/Contraste 1.png";
import chuletaCerdo from "./assets/menu/DSC05091.png";
import arrozMixto from "./assets/menu/DSC05283 1.png";
import costilla from "./assets/menu/DSC05254 1.png";
import carneAhumada from "./assets/menu/DSC05156.png";
import FileteCerdoAsado from "./assets/menu/DSC05200.png";
import FiletePolloAsado from "./assets/menu/DSC05097.png";
import lenguaGuisada from "./assets/menu/DSC05156.png";
import jarraLimonada from "./assets/menu/DSC05340.png";
import jarraNaranjada from "./assets/menu/DSC05319.png";
import jarraMaracuya from "./assets/menu/DSC05326.png";
import almuerzo from "./assets/menu/DSC05138.png";

export const CONFIG = {
  restaurantName: "La Sazón de Holmes",
  tagline: "Tradición Familiar desde 1993",
  logo: logo, // Puedes usar emoji o URL de imagen
  whatsappNumber: "573172486495", // Sin + ni espacios
  phone: "+57 317 248 6495", // Para mostrar
  address: "Carrera 8 # 21-17",
  schedule: "Lun - Dom: 11:00 AM - 12:00 AM",
  currency: "$",
  delivery: true,
  deliveryCost: 3000,
};

// 🍔 PRODUCTOS DEL MENÚ
// Añade, edita o elimina productos según necesites

// export const PRODUCTS = [
//   // 🍔 HAMBURGUESAS
//   {
//     id: 1,
//     name: "Hamburguesa Clásica",
//     price: 15000,
//     image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=500",
//     category: "Hamburguesas",
//     defaultIngredients: ["Carne", "Lechuga", "Tomate", "Cebolla", "Queso", "Salsa de tomate", "Mayonesa"],
//     extras: [
//       { name: "Carne extra", price: 5000 },
//       { name: "Queso extra", price: 2000 },
//       { name: "Tocineta", price: 3000 },
//     ],
//   },
//   {
//     id: 2,
//     name: "Hamburguesa BBQ",
//     price: 18000,
//     image: "https://images.unsplash.com/photo-1550547660-d9450f859349?w=500",
//     category: "Hamburguesas",
//     defaultIngredients: ["Carne", "Lechuga", "Tomate", "Cebolla caramelizada", "Queso cheddar", "Salsa BBQ"],
//     extras: [
//       { name: "Carne extra", price: 5000 },
//       { name: "Aros de cebolla", price: 3000 },
//     ],
//   },
//   {
//     id: 3,
//     name: "Hamburguesa de Pollo",
//     price: 16000,
//     image: "https://images.unsplash.com/photo-1606755962773-d324e0a13086?w=500",
//     category: "Hamburguesas",
//     defaultIngredients: ["Pollo empanizado", "Lechuga", "Tomate", "Queso", "Mayonesa"],
//     extras: [
//       { name: "Pollo extra", price: 4000 },
//       { name: "Queso extra", price: 2000 },
//     ],
//   },

//   // 🌭 PERROS CALIENTES
//   {
//     id: 8,
//     name: "Perro Americano",
//     price: 12000,
//     image: "https://images.unsplash.com/photo-1619740455993-9e612b1af08a?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGhvdCUyMGRvZ3xlbnwwfHwwfHx8MA%3D%3D&fm=jpg&q=80&w=500",
//     category: "Perros Calientes",
//     defaultIngredients: ["Salchicha americana", "Pan", "Papas ripiadas", "Queso", "Salsas"],
//     extras: [
//       { name: "Tocineta", price: 2000 },
//       { name: "Queso extra", price: 1500 },
//     ],
//   },
//   {
//     id: 9,
//     name: "Perro Mexicano",
//     price: 14000,
//     image: "https://images.unsplash.com/photo-1641246630294-c48c8aec58fc?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8aG90JTIwZG9nJTIwbWV4aWNhbnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&q=80&w=500",
//     category: "Perros Calientes",
//     defaultIngredients: ["Salchicha", "Guacamole", "Jalapeños", "Queso", "Salsa BBQ"],
//     extras: [
//       { name: "Jalapeños extra", price: 1000 },
//       { name: "Guacamole extra", price: 2000 },
//     ],
//   },

//   // 🍕 PIZZAS
//   {
//     id: 10,
//     name: "Pizza Pepperoni",
//     price: 25000,
//     image: "https://images.unsplash.com/photo-1594007654729-407eedc4be65?w=500",
//     category: "Pizzas",
//     defaultIngredients: ["Masa artesanal", "Salsa napolitana", "Queso mozzarella", "Pepperoni"],
//     extras: [
//       { name: "Extra Queso", price: 3000 },
//       { name: "Borde de queso", price: 3500 },
//     ],
//   },
//   {
//     id: 11,
//     name: "Pizza Hawaiana",
//     price: 24000,
//     image: "https://images.unsplash.com/photo-1613160774588-d8ac9ad7eded?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fHBpenphJTIwaGF3YWluYXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&q=80&w=500",
//     category: "Pizzas",
//     defaultIngredients: ["Jamón", "Piña", "Queso mozzarella", "Salsa napolitana"],
//     extras: [
//       { name: "Piña extra", price: 1000 },
//       { name: "Borde relleno", price: 3500 },
//     ],
//   },

//   // 🍟 ACOMPAÑAMIENTOS
//   {
//     id: 4,
//     name: "Papas Fritas",
//     price: 6000,
//     image: "https://images.unsplash.com/photo-1573080496219-bb080dd4f877?w=500",
//     category: "Acompañamientos",
//     defaultIngredients: [],
//     extras: [
//       { name: "Queso cheddar", price: 2000 },
//       { name: "Tocineta", price: 2500 },
//     ],
//   },
//   {
//     id: 5,
//     name: "Aros de Cebolla",
//     price: 7000,
//     image: "https://images.unsplash.com/photo-1639024471283-03518883512d?w=500",
//     category: "Acompañamientos",
//     defaultIngredients: [],
//     extras: [{ name: "Salsa ranch", price: 1000 }],
//   },

//   // 🍨 POSTRES
//   {
//     id: 12,
//     name: "Brownie con Helado",
//     price: 10000,
//     image: "https://images.unsplash.com/photo-1624353365286-3f8d62daad51?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8YnJvd25pZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&q=80&w=500",
//     category: "Postres",
//     defaultIngredients: ["Brownie", "Helado de vainilla", "Sirope de chocolate"],
//     extras: [
//       { name: "Extra helado", price: 2000 },
//       { name: "Chispas de chocolate", price: 1500 },
//     ],
//   },
//   {
//     id: 13,
//     name: "Cheesecake de Fresa",
//     price: 9500,
//     image: "https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=500",
//     category: "Postres",
//     defaultIngredients: ["Queso crema", "Base de galleta", "Mermelada de fresa"],
//     extras: [{ name: "Extra mermelada", price: 1000 }],
//   },

//   // 🥤 BEBIDAS
//   {
//     id: 6,
//     name: "Coca-Cola",
//     price: 3000,
//     image: "https://images.unsplash.com/photo-1554866585-cd94860890b7?w=500",
//     category: "Bebidas",
//     defaultIngredients: [],
//     extras: [],
//   },
//   {
//     id: 7,
//     name: "Sprite",
//     price: 3000,
//     image: "https://images.unsplash.com/photo-1696706980174-79c1c11aa683?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fHNwcml0ZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&q=80&w=500",
//     category: "Bebidas",
//     defaultIngredients: [],
//     extras: [],
//   },
//   {
//     id: 14,
//     name: "Limonada Natural",
//     price: 4000,
//     image: "https://images.unsplash.com/photo-1600271886742-f049cd451bba?w=500",
//     category: "Bebidas",
//     defaultIngredients: [],
//     extras: [],
//   },
//   {
//     id: 15,
//     name: "Malteada de Chocolate",
//     price: 7000,
//     image: "https://plus.unsplash.com/premium_photo-1667544654787-cd984212004d?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fG1hbHRlYWRhfGVufDB8fDB8fHww&auto=format&fit=crop&q=80&w=500",
//     category: "Bebidas",
//     defaultIngredients: ["Helado", "Leche", "Chocolate"],
//     extras: [{ name: "Crema batida", price: 1000 }],
//   },

//   // 🍔 COMBOS
//   {
//     id: 16,
//     name: "Combo Clásico",
//     price: 20000,
//     image: "https://images.unsplash.com/photo-1551782450-a2132b4ba21d?w=500",
//     category: "Combos",
//     defaultIngredients: ["Hamburguesa Clásica", "Papas Fritas", "Coca-Cola"],
//     extras: [{ name: "Salsa adicional", price: 500 }],
//   },
//   {
//     id: 17,
//     name: "Combo Familiar",
//     price: 55000,
//     image: "https://images.unsplash.com/photo-1576867757603-05b134ebc379?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8ZmFtaWx5JTIwbWVhbHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&q=80&w=500",
//     category: "Combos",
//     defaultIngredients: ["2 Hamburguesas", "1 Pizza", "2 Gaseosas", "Papas Fritas grandes"],
//     extras: [{ name: "Postre adicional", price: 6000 }],
//   },
// ];

export const PRODUCTS = [
  {
    id: 1,
    name: "Chuleta de Cerdo Apanado",
    price: 12000,
    image: chuletaCerdo,
    category: "Personales",
    defaultIngredients: [
      "Filete de Cerdo Apanado",
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 2,
    name: "Chuleta de Pollo Apanado",
    price: 12000,
    image: chuletaCerdo,
    category: "Personales",
    defaultIngredients: [
      "Filete de Pollo Apanado",
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 3,
    name: "Arroz Mixto",
    price: 12000,
    image: arrozMixto,
    category: "Personales",
    defaultIngredients: [
      "Filete de cerdo",
      "Filete de pollo",
      "Costilla ahumada",
      "Limón",
      "Especias",
      "Cebolla",
      "Tomate",
      "Arbeja",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 4,
    name: "Huevos Pericos Premium",
    price: 12000,
    image:
      "https://www.donhuevon.cl/wp-content/uploads/2017/12/bed-u-benedora-huevo-revuelto-con-tomate-al-I5K7PGU5LZC2VOP442HXOGOQHA-1.jpg",
    category: "Personales",
    defaultIngredients: [
      "Cebolla",
      "Tomate",
      "Arroz blanco",
      "Maduro frito",
      "Arepa asada",
      "Queso",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de maduro frito", price: 2000 },
      { name: "Porción de arepa asada", price: 2000 },
      { name: "Porción de queso", price: 2000 },
    ],
  },
  {
    id: 5,
    name: "1/4 Chuleta de cerdo apanado",
    price: 17000,
    image: chuletaCerdo,
    category: "1/4 Un cuarto de porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },

  // 🍗 OTROS
  {
    id: 6,
    name: "1/4 Chuleta de pollo apanado",
    price: 17000,
    image: chuletaCerdo,
    category: "1/4 Un cuarto de porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },

  // 🍚 ARROCES
  {
    id: 7,
    name: "1/4 Costilla ahumada",
    price: 17000,
    image: costilla,
    category: "1/4 Un cuarto de porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 8,
    name: "1/4 Carne ahumada",
    price: 17000,
    image: carneAhumada,
    category: "1/4 Un cuarto de porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 9,
    name: "1/4 Filete de cerdo asado",
    price: 17000,
    image: FileteCerdoAsado,
    category: "1/4 Un cuarto de porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 10,
    name: "1/4 Filete de pollo asado",
    price: 17000,
    image: FiletePolloAsado,
    category: "1/4 Un cuarto de porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 11,
    name: "1/4 Lengua guisada",
    price: 17000,
    image: lenguaGuisada,
    category: "1/4 Un cuarto de porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 12,
    name: "1/4 Sobre Barriga",
    price: 17000,
    image:
      "https://cdn.colombia.com/gastronomia/2011/08/01/sobrebarriga-al-horno-1702.gif",
    category: "1/4 Un cuarto de porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 13,
    name: "1/4 Bistec de carne",
    price: 17000,
    image:
      "https://t4.ftcdn.net/jpg/05/28/94/29/360_F_528942993_0ehmG830TosccgTtayonzkHNDhsnLxUS.jpg",
    category: "1/4 Un cuarto de porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 14,
    name: "1/4 Carne asada Premium",
    price: 17000,
    image:
      "https://img.freepik.com/fotos-premium/plato-filetes-papas-fritas-arroz-taza-ketchup_577115-6927.jpg",
    category: "1/4 Un cuarto de porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 15,
    name: "1/4 Huevos pericos Premium",
    price: 17000,
    image:
      "https://www.donhuevon.cl/wp-content/uploads/2017/12/bed-u-benedora-huevo-revuelto-con-tomate-al-I5K7PGU5LZC2VOP442HXOGOQHA-1.jpg",
    category: "1/4 Un cuarto de porción",
    defaultIngredients: [
      "Cebolla",
      "Tomate",
      "Arroz blanco",
      "Maduro frito",
      "Arepa asada",
      "Queso",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de maduro frito", price: 2000 },
      { name: "Porción de arepa asada", price: 2000 },
      { name: "Porción de queso", price: 2000 },
    ],
  },

  //1/2

  {
    id: 16,
    name: "1/2 Chuleta de cerdo apanado",
    price: 37000,
    image: chuletaCerdo,
    category: "1/2 Media porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },

  // 🍗 OTROS
  {
    id: 17,
    name: "1/2 Chuleta de pollo apanado",
    price: 37000,
    image: chuletaCerdo,
    category: "1/2 Media porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },

  // 🍚 ARROCES
  {
    id: 18,
    name: "1/2 Costilla ahumada",
    price: 37000,
    image: costilla,
    category: "1/2 Media porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 19,
    name: "1/2 Carne ahumada",
    price: 37000,
    image: carneAhumada,
    category: "1/2 Media porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 20,
    name: "1/2 Filete de cerdo asado",
    price: 37000,
    image: FileteCerdoAsado,
    category: "1/2 Media porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 21,
    name: "1/2 Filete de pollo asado",
    price: 37000,
    image: FiletePolloAsado,
    category: "1/2 Media porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 22,
    name: "1/2 Lengua guisada",
    price: 37000,
    image: lenguaGuisada,
    category: "1/2 Media porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 23,
    name: "1/2 Sobre Barriga",
    price: 37000,
    image:
      "https://cdn.colombia.com/gastronomia/2011/08/01/sobrebarriga-al-horno-1702.gif",
    category: "1/2 Media porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 24,
    name: "1/2 Bistec de carne",
    price: 37000,
    image:
      "https://t4.ftcdn.net/jpg/05/28/94/29/360_F_528942993_0ehmG830TosccgTtayonzkHNDhsnLxUS.jpg",
    category: "1/2 Media porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 25,
    name: "1/2 Carne asada Premium",
    price: 37000,
    image:
      "https://img.freepik.com/fotos-premium/plato-filetes-papas-fritas-arroz-taza-ketchup_577115-6927.jpg",
    category: "1/2 Media porción",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 26,
    name: "1/2 Huevos pericos Premium",
    price: 37000,
    image:
      "https://www.donhuevon.cl/wp-content/uploads/2017/12/bed-u-benedora-huevo-revuelto-con-tomate-al-I5K7PGU5LZC2VOP442HXOGOQHA-1.jpg",
    category: "1/2 Media porción",
    defaultIngredients: [
      "Cebolla",
      "Tomate",
      "Arroz blanco",
      "Maduro frito",
      "Arepa asada",
      "Queso",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de maduro frito", price: 2000 },
      { name: "Porción de arepa asada", price: 2000 },
      { name: "Porción de queso", price: 2000 },
    ],
  },

  // 1 ENTERO

  {
    id: 27,
    name: "1 Entero de Chuleta de cerdo apanado",
    price: 52000,
    image: chuletaCerdo,
    category: "1 Entero Total",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },

  // 🍗 OTROS
  {
    id: 28,
    name: "1 Entero de Chuleta de pollo apanado",
    price: 52000,
    image: chuletaCerdo,
    category: "1 Entero Total",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },

  // 🍚 ARROCES
  {
    id: 29,
    name: "1 Entero de Costilla ahumada",
    price: 52000,
    image: costilla,
    category: "1 Entero Total",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 30,
    name: "1 Entero de Carne ahumada",
    price: 52000,
    image: carneAhumada,
    category: "1 Entero Total",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 31,
    name: "1 Entero de Filete de cerdo asado",
    price: 52000,
    image: FileteCerdoAsado,
    category: "1 Entero Total",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 32,
    name: "1 Entero de Filete de pollo asado",
    price: 52000,
    image: FiletePolloAsado,
    category: "1 Entero Total",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 33,
    name: "1 Entero de Lengua guisada",
    price: 52000,
    image: lenguaGuisada,
    category: "1 Entero Total",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 34,
    name: "1 Entero de Sobre Barriga",
    price: 52000,
    image:
      "https://cdn.colombia.com/gastronomia/2011/08/01/sobrebarriga-al-horno-1702.gif",
    category: "1 Entero Total",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 35,
    name: "1 Entero de Bistec de carne",
    price: 52000,
    image:
      "https://t4.ftcdn.net/jpg/05/28/94/29/360_F_528942993_0ehmG830TosccgTtayonzkHNDhsnLxUS.jpg",
    category: "1 Entero Total",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 36,
    name: "1 Entero de Carne asada Premium",
    price: 52000,
    image:
      "https://img.freepik.com/fotos-premium/plato-filetes-papas-fritas-arroz-taza-ketchup_577115-6927.jpg",
    category: "1 Entero Total",
    defaultIngredients: [
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },
  {
    id: 37,
    name: "1 Entero de Huevos pericos Premium",
    price: 52000,
    image:
      "https://www.donhuevon.cl/wp-content/uploads/2017/12/bed-u-benedora-huevo-revuelto-con-tomate-al-I5K7PGU5LZC2VOP442HXOGOQHA-1.jpg",
    category: "1 Entero Total",
    defaultIngredients: [
      "Cebolla",
      "Tomate",
      "Arroz blanco",
      "Maduro frito",
      "Arepa asada",
      "Queso",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de maduro frito", price: 2000 },
      { name: "Porción de arepa asada", price: 2000 },
      { name: "Porción de queso", price: 2000 },
    ],
  },
  {
    id: 53,
    name: "Almuerzo Ejecutivo ",
    price: 15000,
    image:
      almuerzo,
    category: "Almuerzo Ejecutivo",
    defaultIngredients: [
      "Exquisita Sopa del día",
      "Acompañamiento con Chuleta de cerdo",
      "Acompañamiento con Chuleta de pollo",
      "Acompañamiento con Chuleta de sobre barriga",
      "Limón",
      "Especias",
      "Arroz blanco",
      "Papas fritas",
      "Hogao",
      "Salsa de la casa",
      "Vaso de limonada incluida",
    ],
    extras: [
      { name: "Porción de arroz blanco", price: 3000 },
      { name: "Porción de papas fritas", price: 2000 },
      { name: "Ensalada", price: 2500 },
      { name: "Hogao", price: 3000 },
      { name: "Salsa de la casa", price: 1000 },
    ],
  },

  // 🥤 BEBIDAS
  {
    id: 38,
    name: "Coca-Cola 350 ml",
    price: 3000,
    image: "https://www.seingayhar.com/image/cache/catalog/11%2011/coca2-1000x1000.JPG",
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 39,
    name: "Coca-Cola 1.5 L",
    price: 10000,
    image: "https://static.paodeacucar.com/img/uploads/1/191/24599191.jpg",
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 40,
    name: "Coca-Cola 400 ml",
    price: 4000,
    image: "https://papeleriayvariedades.com/3457-large_default/coca-cola-original-400-ml.jpg",
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 41,
    name: "Postobón 350 ml",
    price: 3000,
    image: "https://tse2.mm.bing.net/th/id/OIP.bx56KuML8FsQsUymRzzVLgHaHa?rs=1&pid=ImgDetMain&o=7&rm=3",
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 42,
    name: "Postobón 1.5 L",
    price: 8000,
    image: "https://supermu.com/cdn/shop/files/supermercados_la_vaquita_supervaquita_GASEOSA_POSTOBON_1.5L_UVA_ZERO_1200x1200.jpg?v=1747898274",
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 43,
    name: "Agua H2O 500 ml",
    price: 4000,
    image: "https://cdn.awsli.com.br/300x300/1330/1330028/produto/177297813/6e2eed8665.jpg",
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 44,
    name: "Botella de agua",
    price: 3000,
    image: "https://pacardylwpmedia.s3.us-east-2.amazonaws.com/wp-content/uploads/2021/08/09194050/7702090022711-600x600.jpg",
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 45,
    name: "Cerveza Poker",
    price: 5000,
    image: "https://colanta.vtexassets.com/arquivos/ids/156782/443I-1.png?v=638096763271730000",
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 46,
    name: "Cerveza Club Colombia",
    price: 5000,
    image: "https://tse1.mm.bing.net/th/id/OIP.0ce5dm2DotAvpcXTYZSoKgHaHa?rs=1&pid=ImgDetMain&o=7&rm=3",
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 47,
    name: "Cerveza Aguila Light",
    price: 5000,
    image: "https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/945b0976043789.5df7f96fa31ef.jpg",
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 48,
    name: "Cerveza Cola y Pola",
    price: 5000,
    image: "https://tse4.mm.bing.net/th/id/OIP.F6350COw8uHc4CW4pVZ8YgHaHa?rs=1&pid=ImgDetMain&o=7&rm=3",
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 49,
    name: "Jugo Hit 500 ml",
    price: 4000,
    image: "https://tse1.mm.bing.net/th/id/OIP.zdGLlI2NMxm1kzBihH4zLQHaHa?rs=1&pid=ImgDetMain&o=7&rm=3",
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 50,
    name: "Jarra de limonada",
    price: 8000,
    image: jarraLimonada,
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 51,
    name: "Jarra de naranjada",
    price: 8000,
    image: jarraNaranjada,
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },
  {
    id: 52,
    name: "Jarra de jugo de maracuyá",
    price: 8000,
    image: jarraMaracuya,
    category: "Bebidas",
    defaultIngredients: [],
    extras: [],
  },


  // {
  //   id: 11,
  //   name: "Limonada Natural",
  //   price: 4000,
  //   image:
  //     "https://plus.unsplash.com/premium_photo-1714245922334-7af56ed94910?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8ZnJpZWQlMjBiYW5hbmF8ZW58MHx8MHx8fDA=?auto=format&fit=crop&q=60&w=500",
  //   category: "Bebidas",
  //   defaultIngredients: [],
  //   extras: [],
  // },
  // {
  //   id: 12,
  //   name: "Malteada de Chocolate",
  //   price: 7000,
  //   image:
  //     "https://images.unsplash.com/photo-1500040760498-8be2dccbdea7?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cmljZSUyMHdpdGglMjBzaHJpbXB8ZW58MHx8MHx8fDA=?auto=format&fit=crop&q=60&w=500",
  //   category: "Bebidas",
  //   defaultIngredients: ["Helado", "Leche", "Chocolate"],
  //   extras: [{ name: "Crema batida", price: 1000 }],
  // },

  // {
  //   id: 13,
  //   name: "Porción de Arroz Blanco",
  //   price: 3000,
  //   image:
  //     "https://images.unsplash.com/photo-1500040760498-8be2dccbdea7?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cmljZSUyMHdpdGglMjBzaHJpbXB8ZW58MHx8MHx8fDA=?auto=format&fit=crop&q=60&w=500",
  //   category: "Adicionales",
  //   defaultIngredients: [],
  //   extras: [],
  // },
  // {
  //   id: 14,
  //   name: "Porción de Arroz Coco",
  //   price: 4000,
  //   image:
  //     "https://images.unsplash.com/photo-1500040760498-8be2dccbdea7?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cmljZSUyMHdpdGglMjBzaHJpbXB8ZW58MHx8MHx8fDA=?auto=format&fit=crop&q=60&w=500",
  //   category: "Adicionales",
  //   defaultIngredients: [],
  //   extras: [],
  // },
  // {
  //   id: 15,
  //   name: "Porción de Patacón",
  //   price: 2000,
  //   image:
  //     "https://images.unsplash.com/photo-1598515214211-89d3c73ae83b?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y2hpY2tlbiUyMGZpbGxldHxlbnwwfHwwfHx8MA==&auto=format&fit=crop&q=60&w=500",
  //   category: "Adicionales",
  //   defaultIngredients: [],
  //   extras: [],
  // },
  // {
  //   id: 16,
  //   name: "Ensalada",
  //   price: 2500,
  //   image:
  //     "https://images.unsplash.com/photo-1500040760498-8be2dccbdea7?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cmljZSUyMHdpdGglMjBzaHJpbXB8ZW58MHx8MHx8fDA=?auto=format&fit=crop&q=60&w=500",
  //   category: "Adicionales",
  //   defaultIngredients: [],
  //   extras: [],
  // },
  // {
  //   id: 17,
  //   name: "Patacón con Hogao",
  //   price: 3000,
  //   image:
  //     "https://images.unsplash.com/photo-1598515214211-89d3c73ae83b?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y2hpY2tlbiUyMGZpbGxldHxlbnwwfHwwfHx8MA==&auto=format&fit=crop&q=60&w=500",
  //   category: "Adicionales",
  //   defaultIngredients: [],
  //   extras: [],
  // },
];
